import React, { useState } from 'react'
import { Box } from '@mui/material'
import PropTypes from 'prop-types'

function downloadBadge(endpoint) {
  const params = new URLSearchParams({
    url: endpoint, query: '$.downloads', label: 'downloads/mo',
    logo: 'huggingface', style: 'social', cacheSeconds: '3600',
  })
  return `https://img.shields.io/badge/dynamic/json?${params}`
}

const badges = {
  'https://huggingface.co/datasets/microsoft/ProgramDistill': {
    src: downloadBadge('https://huggingface.co/api/datasets/microsoft/ProgramDistill?expand=downloads'),
    description: 'ProgramDistill dataset downloads in the last month on Hugging Face',
  },
  'https://huggingface.co/microsoft/FrogNano-4B-2609': {
    src: downloadBadge('https://huggingface.co/api/models/microsoft/FrogNano-4B-2609?expand=downloads'),
    description: 'FrogNano model downloads in the last month on Hugging Face',
  },
  'https://github.com/beanie00/self-distillation-analysis': {
    src: 'https://img.shields.io/github/stars/beanie00/self-distillation-analysis?style=social&logo=github&label=stars&cacheSeconds=3600',
    description: 'Self-distillation analysis GitHub stars',
  },
}

export default function ResourceBadge({ url }) {
  const [failed, setFailed] = useState(null)
  const badge = badges[url]
  if (!badge || failed === url) return null
  return (
    <Box component="a" data-resource-badge href={url} target="_blank" rel="noopener noreferrer" title={badge.description}
      sx={{ display: 'inline-flex', alignItems: 'center', height: '20px', lineHeight: 1, alignSelf: 'center', ml: 0.75 }}>
      <Box component="img" src={badge.src} alt={badge.description} height={20}
        onError={() => setFailed(url)} sx={{ display: 'block', width: 'auto' }} />
    </Box>
  )
}

ResourceBadge.propTypes = { url: PropTypes.string.isRequired }
